import React, { useState, useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";
import { API } from "aws-amplify";
import {
  validatorField,
} from "../../Utils/validators";

import ErrorCustom from "../../Components/errorCustom";

interface Params {
  department?: object | null;
  province?: object | null;
  setUbigeoCode?: any
}

interface UbigeoItem {
  codigo: string;
  descripcion: string;
}

export const Ubigeo = ({
  setNameUbigeo,
  nameUbigeo,
  setUbigeoCode,
  setUbigeoCodeObject,
  isDisabled = false,
}: any) => {
  const methods: any | undefined = useFormContext();
  const [loading, setLoading] = useState<boolean>(false);
  const [department, setDepartment] = useState<null>(null);
  const [dataDepart, setDataDepart] = useState<UbigeoItem[]>([]);
  const [dataProv, setDataProv] = useState<UbigeoItem[]>([]);
  const [dataCodeUbigeo, setDataUbigeoCode] = useState<any>();
  const [dataDist, setDataDist] = useState<UbigeoItem[]>([]);
  const inputEl = useRef(null);
  const hasPreloaded = useRef(false);

  const [isFill, setIsFill] = useState<boolean>(false);

  const isEmptyValue = (): boolean => {
    const elem = inputEl.current || null;
    if (elem) {
      const input = (elem as HTMLElement).querySelector("input");
      return input ? input.value.trim().length > 0 : true;
    }

    return true;
  };

  const setFill = () => {
    setIsFill(!isEmptyValue());
  };

  useEffect(() => {
    setFill();
  }, []);

  useEffect(() => {
    getUbigeos(null, null, null);
  }, []);

  useEffect(() => {
    methods.register("address.department", { validate: validatorField });
    methods.register("address.province", { validate: validatorField });
    methods.register("address.district", { validate: validatorField });
    
    if (!methods.getValues("address.department")) {
      methods.setValue("address.department", "", { shouldValidate: false });
    }
    if (!methods.getValues("address.province")) {
      methods.setValue("address.province", "", { shouldValidate: false });
    }
    if (!methods.getValues("address.district")) {
      methods.setValue("address.district", "", { shouldValidate: false });
    }
  }, []);

  useEffect(() => {
    if (
      nameUbigeo && 
      nameUbigeo.department && nameUbigeo.department.trim() !== '' &&
      nameUbigeo.province && nameUbigeo.province.trim() !== '' &&
      nameUbigeo.district && nameUbigeo.district.trim() !== '' &&
      dataDepart.length > 0 && 
      !hasPreloaded.current
    ) {
      hasPreloaded.current = true;
      preloadUbigeoValues();
    }
  }, [dataDepart, nameUbigeo]);

  const preloadUbigeoValues = async () => {
    try {
      const departmentMatch = dataDepart.find((item: any) => {
        const normalized = item.descripcion.substr(0, 1).toUpperCase() + item.descripcion.substr(1).toLowerCase();
        return normalized === nameUbigeo.department;
      });

      if (departmentMatch) {
        const departCode = String((departmentMatch as any).codigo);
        methods.setValue("address.department", departCode, { shouldValidate: true });
        setDepartment(departCode as any);
        const provinces = await getUbigeos(departCode as any, null, "department");
        const provinceMatch = provinces.find((item: any) => {
          const normalized = item.descripcion.substr(0, 1).toUpperCase() + item.descripcion.substr(1).toLowerCase();
          return normalized === nameUbigeo.province;
        });

        if (provinceMatch) {
          const provCode = String(provinceMatch.codigo);
          methods.setValue("address.province", provCode, { shouldValidate: true });
          const districts = await getUbigeos(departCode as any, provCode as any, "province");
          const districtMatch = districts.find((item: any) => {
            const normalized = item.descripcion.substr(0, 1).toUpperCase() + item.descripcion.substr(1).toLowerCase();
            return normalized === nameUbigeo.district;
          });

          if (districtMatch) {
            const distCode = String(districtMatch.codigo);
            methods.setValue("address.district", distCode, { shouldValidate: true });
            setUbigeoCode(distCode);
            setDataUbigeoCode({
              department: departCode,
              province: provCode,
              district: distCode,
            });
            setUbigeoCodeObject({
              department: departCode,
              province: provCode,
              district: distCode,
            });
          }
        }
      }
    } catch (error) {
      console.error('Error en preload ubigeo:', error);
    }
  };

  const getUbigeos = async (
    depart: object | null,
    prov: object | null,
    filterBy: string | null
  ) => {
    setLoading(true);
    let params: Params = {};
    if (depart) {
      params.department = depart;
    }
    if (prov) {
      params.province = prov;
    }

    const response = await API.post("api-rentas", "/ubigeos", {
      body: params,
      headers: {},
    });

    if (response.status) {
      const { data } = response;
      if (filterBy && typeof filterBy === "string") {
        if (filterBy === "department") {
          setDataProv(data);
          setDataDist([]);
          setDepartment(depart as any);
        } else if (filterBy === "province") {
          setDataDist(data);
        }
      } else {
        setDataDepart(data);
      }
      setLoading(false);
      return data;
    }
    setLoading(false);
    return [];
  };

  const handleChangeDepart = (e: any) => {
    const depart = e.target.value;
    const index = e.target.selectedIndex;
    const nameDepart = e.target[index].text;
    methods.setValue("address.department", depart, { shouldValidate: true });
    
    setUbigeoCode(null)
    setDataUbigeoCode({
      department: depart,
      province: "",
      district: "",
    })
    setNameUbigeo({
      ...nameUbigeo,
      department: nameDepart,
      province: "",
      district: "",
    });
    getUbigeos(depart, null, "department");
    methods.setValue("address.province", "", { shouldValidate: false });
    methods.setValue("address.district", "", { shouldValidate: false });
  };

  const handleChangeProv = (e: any) => {
    const prov = e.target.value;
    const index = e.target.selectedIndex;
    const nameProv = e.target[index].text;
    methods.setValue("address.province", prov, { shouldValidate: true });
    
    setUbigeoCode(null)
    setDataUbigeoCode({
      ...dataCodeUbigeo,
      province: prov,
      district: "",
    })
    setNameUbigeo({
      ...nameUbigeo,
      province: nameProv,
      district: "",
    });
    getUbigeos(department, prov, "province");
    methods.setValue("address.district", "", { shouldValidate: false });
  };

  const handleChangeDist = (e: any) => {
    const distCode = e.target.value;
    const index = e.target.selectedIndex;
    const nameDist = e.target[index].text;
    methods.setValue("address.district", distCode, { shouldValidate: true });
    
    setUbigeoCode(distCode)
    setUbigeoCodeObject({
      ...dataCodeUbigeo,
      district: distCode,
    })
    setNameUbigeo({
      ...nameUbigeo,
      district: nameDist,
    });
  };

  const watchDepartment = methods.watch("address.department");
  const watchProvince = methods.watch("address.province");
  const watchDistrict = methods.watch("address.district");

  const departmentError: any | undefined = methods.errors.address
    ? methods.errors.address.department
    : undefined;
  const provinceError: any | undefined = methods.errors.address
    ? methods.errors.address.province
    : undefined;
  const districtError: any | undefined = methods.errors.address
    ? methods.errors.address.district
    : undefined;

  return (
    <>
      <div className="clientForm__control input-field">
        <select
          className={departmentError ? " is-error" : ""}
          name="address.department"
          value={watchDepartment || ""}
          onChange={(e) => handleChangeDepart(e)}
          disabled={isDisabled}
        >
          <option value="" disabled>
            Departamento
          </option>

          {dataDepart.map((item: any, index) => (
            <option key={index} value={item.codigo}>
              {item.descripcion.substr(0, 1).toUpperCase() +
                item.descripcion.substr(1).toLowerCase()}
            </option>
          ))}
        </select>
        <ErrorCustom errors={methods.errors} name="address.department" />
      </div>

      <div className="clientForm__control input-field">
        <select
          className={provinceError ? " is-error" : ""}
          name="address.province"
          value={watchProvince || ""}
          onChange={(e) => handleChangeProv(e)}
          disabled={isDisabled}
        >
          <option value="" disabled>
            Provincia
          </option>
          {dataProv.map((item: any, index) => (
            <option key={index} value={item.codigo}>
              {item.descripcion.substr(0, 1).toUpperCase() +
                item.descripcion.substr(1).toLowerCase()}
            </option>
          ))}
        </select>
        <ErrorCustom errors={methods.errors} name="address.province" />
      </div>

      <div className="clientForm__control input-field">
        <select
          className={"browser-default" + (districtError ? " is-error" : "")}
          name="address.district"
          value={watchDistrict || ""}
          onChange={(e) => handleChangeDist(e)}
          disabled={isDisabled}
        >
          <option value="" disabled>
            Distrito
          </option>

          {dataDist.map((item: any, index) => (
            <option key={index} value={item.codigo}>
              {item.descripcion.substr(0, 1).toUpperCase() +
                item.descripcion.substr(1).toLowerCase()}
            </option>
          ))}
        </select>
        <ErrorCustom errors={methods.errors} name="address.district" />
      </div>
    </>
  );
};
